import React, { useEffect } from 'react';
import { X } from 'lucide-react';
import { Button } from './Button';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
  footer?: React.ReactNode;
  size?: 'sm' | 'md' | 'lg';
}
export function Modal({
  isOpen,
  onClose,
  title,
  children,
  footer,
  size = 'md'
}: ModalProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);
  if (!isOpen) return null;
  const sizes = {
    sm: 'max-w-md',
    md: 'max-w-2xl',
    lg: 'max-w-4xl'
  };
  return <div className="fixed inset-0 z-50 overflow-y-auto" data-id="element-270">
      <div className="flex min-h-screen items-center justify-center p-4" data-id="element-271">
        <div className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm" onClick={onClose} data-id="element-272" />
        <div className={`relative bg-white rounded-lg shadow-xl w-full ${sizes[size]}`} data-id="element-273">
          <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200" data-id="element-274">
            <h2 className="text-lg font-semibold text-gray-900" data-id="element-275">{title}</h2>
            <button onClick={onClose} className="text-gray-400 hover:text-gray-600 transition-colors" data-id="element-276">
              <X className="w-5 h-5" data-id="element-277" />
            </button>
          </div>
          <div className="px-6 py-4 max-h-[70vh] overflow-y-auto" data-id="element-278">
            {children}
          </div>
          {footer && <div className="px-6 py-4 border-t border-gray-200 flex justify-end gap-3" data-id="element-279">
              {footer}
            </div>}
        </div>
      </div>
    </div>;
}